import { OptionTile } from "@manifesthhqinc/ui-library";
import { TitleLarge } from "../../../components/font";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import ScrollableContainer from "../../../layout/scrollable-container";
import { OptionTileContainer } from "./styles";
import { UseHenryQuestionniareProps } from "../useHenryQuestionnaire";
import HeadingContainer from "../../../layout/heading-container";

const HenryQuestionnaireFive = (props: UseHenryQuestionniareProps) => {
  const { updateHenryQuestionnaire } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="henry-questionnaire-form-1">
        <Container>
          <HeadingContainer paneVariant="optionForm" withProgressBar>
            <TitleLarge>
              Would it be helpful to have the option to borrow from your retirement account if you ever needed to?
            </TitleLarge>
          </HeadingContainer>
          <OptionTileContainer>
            <OptionTile
              name="yes"
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHenryQuestionnaire({ loanImportant: true })}
            >
              Yes, having that option matters to me
            </OptionTile>
            <OptionTile
              name="no"
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHenryQuestionnaire({ loanImportant: false })}
            >
              No, I don’t expect to borrow from it
            </OptionTile>
          </OptionTileContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};
export default HenryQuestionnaireFive;
